import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
 
const CustomDatePicker = ({
  id,
  name,
  label,
  value,
  onChange,
  required = false,
  error,
  minDate,
  maxDate,
  disabled = false,
  placeholder = "dd / mm / yyyy",
  ...otherProps
}) => {
  return (
    <div className="form-row">
      {label && (
        <label htmlFor={id} className="label-one">
          {label}
          {required && <span style={{ color: "#dc2626" }}> *</span>}
        </label>
      )}
 
      <DatePicker
        id={id}
        selected={value ? new Date(value) : null}
        onChange={(date) => onChange(date)}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        className={`form-input ${error ? "has-error" : ""}`}
        autoComplete="off"
        onChangeRaw={(e) => {
          const rawValue = e?.target?.value;
          if (rawValue == null) return;

          let formatted = rawValue.replace(/\D/g, "");

          if (formatted.length > 2) {
            formatted = formatted.slice(0, 2) + "/" + formatted.slice(2);
          }

          if (formatted.length > 5) {
            formatted = formatted.slice(0, 5) + "/" + formatted.slice(5, 9);
          }

          e.target.value = formatted;
        }}
        {...otherProps}
      />
 
      {error && <div className="error-text">{error}</div>}
    </div>
  );
};
 
export default CustomDatePicker;
 
 